/**
 * Sri Lankan Validation Utilities
 */

/**
 * Validates Sri Lankan Phone Number
 * Formats: 07XXXXXXXX, +947XXXXXXXX, 947XXXXXXXX
 */
export const validateSLPhone = (phone) => {
  const mobileRegex = /^(0|94|\+94)?7[0-9]{8}$/;
  return mobileRegex.test(phone);
};

/**
 * Validates Sri Lankan NIC Number
 * Formats: 9 digits + V/X (Old) or 12 digits (New)
 */
export const validateSLNIC = (nic) => {
  if (!nic) return false;
  const nicStr = nic.toString().trim().toUpperCase();
  return /^([0-9]{9}[V|X]|[0-9]{12})$/.test(nicStr);
};

/**
 * Validates Standard Email Address
 */
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Sanitizes Phone Input (removes non-numeric except +)
 */
export const sanitizePhone = (val) => {
  return val.replace(/[^0-9+]/g, '');
};

/**
 * Sanitizes NIC Input (capitalizes and constraints)
 */
export const sanitizeNIC = (val) => {
  let cleaned = val.replace(/[^0-9vxVX]/g, '').toUpperCase();
  if (cleaned.length > 12) cleaned = cleaned.substring(0, 12);
  return cleaned;
};
